import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type ldtnCredType = CarrierLogisticsCredType

export const ldtnDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ldtn: CarrierDef<ldtnCredType> = {
  name: 'Line Drive Trucking',
  scac: 'ldtn',
  ...carrierLogistics,
  engineLayers: [
    'rating',
    'pickup',
    'profinder',
    'documents',
    'tracking',
    'invoice',
  ],
  documentTypes: ldtnDocumentTypes,
}
